module.exports = __webpack_public_path__ + "static/img/M-615-OLIVO.13ca729.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-615-OLIVO.png
// module id = FmYY
// module chunks = 0